import style from "./invite-emails.module.css";
import React from "react";
import { InviteResponse } from "frontend/utils/invite-utils";
import { CloseIcon } from "./svg-shapes";
import { getPathPrefix } from "../utils/getPathPrefix";

export function InviteFailedEmailsList({ failedEmails }: { failedEmails: string[] }) {
  const failedCount = failedEmails.length;
  const failedEamilsString = failedEmails.join(", ");
  return (
    <div className={style.failedContainer}>
      <div className={style.failedStrip}>
        <div className={style.invitationFailed}>
          <CloseIcon color={"#F8746B"} style={{ marginTop: 2 }} />
          <div>
            <span>{`${failedCount} invitation${failedCount > 1 ? "s" : ""} failed!`}</span>
            <div className={style.failedEmails}>
              <span className={style.failedEmailRow}>{failedEamilsString}</span>
            </div>
          </div>
        </div>
      </div>
      <div className={style.failedMessageContainer}>
        <img src={getPathPrefix("/images/error-info-icon.svg")} />
        <div className={style.failedMessage}>You don&apos;t have permission to invite new people to the account</div>
      </div>
    </div>
  );
}

export function renderResponseStrip(inviteUsersResponse: InviteResponse | null, additionalText: string = "") {
  if (inviteUsersResponse) {
    const invitedCount = inviteUsersResponse.usersCount;
    const failedEmails = inviteUsersResponse.failed;
    const failedCount = failedEmails.length;
    const responseStipe = [];

    if (invitedCount) {
      responseStipe.push(
        <div className={style.successStrip}>
          <img src={getPathPrefix("/images/green-checkmark.svg")} />
          <span>
            <p>{`${invitedCount} invitation${invitedCount > 1 ? "s" : ""} sent!`}</p>
            <p>{additionalText}</p>
          </span>
        </div>
      );
    }
    if (failedCount) {
      responseStipe.push(<InviteFailedEmailsList failedEmails={failedEmails} />);
    }
    return (
      <>
        {responseStipe.map((element, index) => (
          <div key={index}>{element}</div>
        ))}
      </>
    );
  }
  return null;
}
